<div class="modal-header">
  <div>
    <span class="h3 m-0 d-block fw-bold"
          [translate]="'SHARED.COOKIE-CONSENT-POPUP.HEADER'"></span>
  </div>
</div>

<div class="modal-body">
  <p>
    <span *ngIf="!settingsMode"
          [innerHTML]="'SHARED.COOKIE-CONSENT-POPUP.MESSAGE' | translate"></span>
    <span *ngIf="settingsMode"
          [innerHTML]="'SHARED.COOKIE-CONSENT-POPUP.MESSAGE-SETTINGS' | translate"></span>
  </p>

  <div *ngIf="settingsMode"
       class="d-flex align-items-center">
    <ui-switch class="me-3"
               [(ngModel)]="analyticsEnabled"
               [color]="switchColor"></ui-switch>
    <span *ngIf="analyticsEnabled"
          [translate]="'SHARED.COOKIE-CONSENT-POPUP.ANALYTICS-ENABLED'"></span>
    <span *ngIf="!analyticsEnabled"
          [translate]="'SHARED.COOKIE-CONSENT-POPUP.ANALYTICS-DISABLED'"></span>
  </div>

</div>

<div class="modal-footer">
  <button *ngIf="!settingsMode"
          (click)="toggleSettingsMode()"
          type="button"
          class="btn btn-link">
    <span class="small">
      {{'SHARED.COOKIE-CONSENT-POPUP.SETTINGS' | translate}}
    </span>
  </button>
  <button (click)="onCloseClicked()"
          type="button"
          class="btn btn-primary btn-lg shadow-sm">
    <span *ngIf="!settingsMode"
          [translate]="'SHARED.COOKIE-CONSENT-POPUP.ALLOW-AND-CLOSE'">
    </span>
    <span *ngIf="settingsMode"
          [translate]="'SHARED.COOKIE-CONSENT-POPUP.SAVE-AND-CLOSE'">
    </span>
  </button>
</div>
